import { render, staticRenderFns } from "./VideoPanels.vue?vue&type=template&id=01293f8c&"
import script from "./VideoPanels.vue?vue&type=script&lang=js&"
export * from "./VideoPanels.vue?vue&type=script&lang=js&"
import style0 from "./VideoPanels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports